var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOpeningAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 15,
    viewBox: "0 0 94 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.48212H86.8734",
    stroke: "#fbfaf8",
    strokeWidth: 1.82701,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4205 7.79272L86.873 3.24524L82.3256 7.79272L86.873 12.3402L91.4205 7.79272Z",
    fill: "#fbfaf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4205 7.79272L86.873 3.24524L82.3256 7.79272L86.873 12.3402L91.4205 7.79272Z",
    fill: "#fbfaf8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.7559,
    y: 7.48206,
    width: 10.0655,
    height: 10.0655,
    transform: "rotate(-45 79.7559 7.48206)",
    fill: "#fbfaf8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.5686,
    height: 9.74406,
    fill: "#fbfaf8",
    transform: "translate(0 3.21912)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpeningAbout);
export default __webpack_public_path__ + "static/media/icon-opening-about.89474613e926a3ef58ffbabcf25feaf0.svg";
export { ForwardRef as ReactComponent };